import _OnlineHomeworkResult from './model';
import create from './create';

const OnlineHomeworkResult = _OnlineHomeworkResult;

OnlineHomeworkResult.create = create;

export default OnlineHomeworkResult;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/OnlineHomeworkResult/index.js